export default {
  'authenticated_routes.company_summary_report_name': 'Company Summary Report',
  'authenticated_routes.company_team_risk_report_name': 'Team Risk Report',
  'authenticated_routes.company_team_reliability_report_name':
    'Team Score Report'
}
